<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="tabs flex">
        <div class="tabs-l">
          <el-button type="primary" round size="small">最热</el-button>
          <el-button type="info" round size="small">最新</el-button>
        </div>
        <div class="tabs-r">
          <el-button type="primary" size="small">我的报名</el-button>
        </div>
      </div>
      <ul class="studyList cl">
        <router-link
          tag="li"
          :to="{path: '/offlineDetail',query:{courseId:item.courseId}}"
          v-for="(item, i) in dataList"
          :key="i"
        >
          <div class="box bs cur">
            <div class="img-wrap">
              <img :src="item.coursePic" alt />
              <div class="detail">
                <p>讲师: {{item.courseTeacher}}</p>
                <p>优惠价格: {{item.courseSaleprice}}元</p>
                <p>开课时间: {{item.openingStart}}</p>
                <p class="adress">地址:{{item.openingAddress}}</p>
              </div>
            </div>
            <h3 class="title ellipsis">{{item.courseName}}</h3>
            <p class="glance">
              <span>课时: {{item.time}}</span>
              <span class="view">浏览量: {{item.num}}</span>
            </p>
          </div>
        </router-link>
      </ul>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";

export default {
  name: "offline",
  components: {
    HeadCom,
    FooterCom
  },
  data() {
    return {
      tabSelect: "1",
      pageNum: 1,
      pageSize: 16,
      dataList: []
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      http
        .getOfflineList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderby: this.tabSelect
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.dataList = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="less" scoped>
.tabs {
  margin: 30px 0;
}
.studyList {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &:after {
    content: "";
    flex: auto;
  }
  li {
    width: 23%;
    height: 260px;
    margin-bottom: 30px;
    margin-right: 30px;
    position: relative;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .box {
      height: 100%;
      width: 100%;
      padding: 12px;
      background: #fff;
      border-radius: 4px;
      position: absolute;
      top: 0;
      transition: 0.3s;
      &:hover {
        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        top: -10px;
      }
    }
    .img-wrap {
      width: 100%;
      height: 160px;
      overflow: hidden;
      position: relative;
      transition: 0.3s;
      &:hover {
        .detail {
          display: block;
        }
      }
      .detail {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #ffffff;
        padding: 20px 10px;
        display: none;
        p {
          line-height: 30px;
        }
        .adress {
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      img {
        width: 100%;
        height: auto;
        min-height: 100%;
      }
    }
    .title {
      margin-top: 10px;
      line-height: 32px;
      // width: 100%;
    }
    .view {
      margin-left: 20px;
    }
  }
}
</style>
